import { CalendarForm } from "~/components/form/calendar/CalendarForm";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function AddJournal() {
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section="calendar">
            <CalendarForm onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
